/* Pariyatti daily widgets: Pali Word a Day, Daily Words of the Buddha, Daily
   Dhamma Verses -- rendered natively in the page instead of the old
   daily.pariyatti.org iframes.

   Usage (anywhere on the store, in any language):
     <div data-piv-daily="pwad"  data-lang="en"></div>
     <div data-piv-daily="dwob"  data-lang="es" data-show="word"></div>
     <div data-piv-daily="dohas" data-lang="lt" data-show="subscribe"></div>
   data-piv-daily  pwad | dwob | dohas
   data-lang       en (default), pt, zh, es, fr, it, pt-br, sr, lt -- which exist
                   depends on the list; the full catalogue is
                   https://daily.pariyatti.org/api/daily.php?list=index
   data-show       both (default) | word | subscribe

   Data: GET https://daily.pariyatti.org/api/daily.php (read-only, CORS-limited to
   this store; it reads the files the existing nightly jobs already write).
   Subscribing POSTs {email, dailylist} to https://api.prytti.me/npo-subscribe --
   the same request the old iframe form made -- and the Sympa list server then
   emails the visitor an invitation to confirm. */
(function () {
  'use strict';

  var DATA_URL = 'https://daily.pariyatti.org/api/daily.php';
  var SUBSCRIBE_URL = 'https://api.prytti.me/npo-subscribe';
  var MANAGE_URL = 'https://subscribe.pariyatti.org/';
  var HTML_LANG = { zh: 'zh-Hant', 'pt-br': 'pt-BR', pt: 'pt' };
  var cache = {};
  var uid = 0;

  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }

  function load(list, lang) {
    var key = list + '/' + lang;
    if (!cache[key]) {
      cache[key] = fetch(DATA_URL + '?list=' + encodeURIComponent(list) + '&lang=' + encodeURIComponent(lang), { credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        });
    }
    return cache[key];
  }

  function renderWord(data) {
    var box = node('div', 'piv-daily__word');
    box.appendChild(node('p', 'piv-daily__date', data.date_label));
    var text = node('p', 'piv-daily__text');
    text.setAttribute('dir', 'auto');
    text.innerHTML = data.html; // sanitised on the server: only text, <br>, <b>/<i>/<em>/<strong> and https links
    box.appendChild(text);
    return box;
  }

  function renderSubscribe(data) {
    var id = 'piv-daily-email-' + (++uid);
    var form = node('form', 'piv-daily__subscribe');
    form.setAttribute('novalidate', '');
    form.appendChild(node('p', 'piv-daily__heading', data.ui.heading));

    var label = node('label', null, data.ui.label);
    label.setAttribute('for', id);
    form.appendChild(label);

    var row = node('div', 'piv-daily__row');
    var input = node('input');
    input.type = 'email';
    input.id = id;
    input.name = 'email';
    input.required = true;
    input.maxLength = 60;
    input.autocomplete = 'email';
    var button = node('button', 'button', data.ui.button);
    button.type = 'submit';
    row.appendChild(input);
    row.appendChild(button);
    form.appendChild(row);

    var status = node('p', 'piv-daily__status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    form.appendChild(status);

    function say(message, kind) {
      status.textContent = message;
      status.className = 'piv-daily__status' + (kind ? ' piv-daily__status--' + kind : '');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        say(data.ui.error, 'error');
        input.focus();
        return;
      }
      button.disabled = true;
      say('…');
      fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, dailylist: data.listname })
      }).then(function (response) {
        if (response.status === 200) { // same success test the old form used
          form.innerHTML = '';
          var ok = node('p', 'piv-daily__status piv-daily__status--ok', data.ui.success);
          ok.setAttribute('role', 'status');
          form.appendChild(ok);
        } else {
          button.disabled = false;
          say(data.ui.error, 'error');
        }
      }).catch(function () {
        button.disabled = false;
        say(data.ui.error, 'error');
      });
    });
    return form;
  }

  // Sign-up stays in the box; managing / unsubscribing lives on the portal.
  function renderManageLink() {
    var p = node('p', 'piv-daily__manage');
    var a = node('a', null, 'Manage all your subscriptions');
    a.href = MANAGE_URL;
    a.lang = 'en';
    p.appendChild(a);
    return p;
  }

  function init(root) {
    if (root.getAttribute('data-piv-daily-ready')) return;
    root.setAttribute('data-piv-daily-ready', '1');
    root.classList.add('piv-daily');
    var list = root.getAttribute('data-piv-daily');
    var lang = root.getAttribute('data-lang') || 'en';
    var show = root.getAttribute('data-show') || 'both';

    root.setAttribute('aria-busy', 'true');
    root.textContent = '';
    root.appendChild(node('p', 'piv-daily__loading', '…'));

    load(list, lang).then(function (data) {
      root.textContent = '';
      root.lang = HTML_LANG[data.lang] || data.lang;
      if (show !== 'subscribe') root.appendChild(renderWord(data));
      if (show !== 'word') {
        root.appendChild(renderSubscribe(data));
        root.appendChild(renderManageLink());
      }
    }).catch(function () {
      root.textContent = '';
      root.appendChild(node('p', 'piv-daily__unavailable', 'Today’s entry is temporarily unavailable. Please try again later.'));
    }).then(function () {
      root.removeAttribute('aria-busy');
    });
  }

  function start() {
    var roots = document.querySelectorAll('[data-piv-daily]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
